module.exports = __webpack_public_path__ + "sunsemweb/img/pbanner22.504843d2.png";